<template>
  <div class="articles d-flex align-items-center justify-content-center px-5" :style="{'background-image': 'url(' + require('@/assets/bgimage4.png') + ')'}">
    <div class="talk-about">
      <three-dots class="dots-mobile-auto"/>
      <h1 class="title">Видео: анализ разных жизненных ситуаций</h1>
      <p>и пути решения проблем</p>
      <router-link to="/video" class="button">Все видео <under-arrow/></router-link>
    </div>
    <div class="articles-block d-flex">
      <div
        class="mb-3 w-50"
        v-for="(item, id) in firstVideos"
        :key="id">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" :src="item.link +'?rel=0'" allowfullscreen></iframe>
        </div>
        <p>{{item.title | truncate(50)}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import ThreeDots from '@/components/icons/ThreeDots';
  import UnderArrow from '@/components/icons/UnderArrow';
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  export default {
    name: "Articles",
    components: {ThreeDots, UnderArrow},
    data() {
      return {
        loading: true
      }
    },
    async mounted() {
      this.loading = true
      const response = await this.fetchFourVideos()
      await this.setVideos(response)
      this.loading = false
    },
    computed: {
      ...mapGetters('video', ['getVideo']),
      firstVideos() {
        return this.getVideo.splice(0, 4)
      }
    },
    filters: {
      truncate: function (value, limit) {
        if (value.length > limit) {
          value = value.substring(0, (limit - 3)) + '...';
        }
        return value
      },
    },
    methods: {
      ...mapMutations('video', ['setVideos']),
      ...mapActions('video', ['fetchFourVideos']),
    }
  }
</script>

<style lang="scss">
  .articles {
    background-position: center;
    background-size: cover;
    min-height: 580px;
    font-family: 'Raleway', sans-serif;
    padding: 48px;
    justify-content: center;
    .talk-about {
      width: 25%;
      margin-right: 117px;
      .title {
        color: #fff;
        text-align: left;
        max-width: 330px;
        margin: 20px 0 0 ;
      }
      p {
        font-size: 17px;
        margin-top: 16px;
        margin-bottom: 24px;
        color: #ffffff;
      }
      .button {
        display: block;
        color: #fff;
        width: 181px;
        height: 48px;
        border-radius: 9px;
        background-color: #5ec8f5;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 17px;
        font-weight: 600;
        line-height: 1;
        color: #ffffff;
        svg {
          margin-left: 15px;
          transform: rotate(-90deg);
        }
      }
    }
    &-block {
      width: 50%;
      max-width: 650px;
      flex-wrap: wrap;
      align-content: start;
      justify-content: space-between;
      .w-50 {
        width: 46% !important;
      }
      div {
        img{
          border-radius: 9px;
        }
        p {
          font-size: 17px;
          font-weight: 600;
          margin-top: 8px;
          margin-bottom: 0;
          color: #ffffff;
        }
      }
      div:nth-child(2n + 2){
        margin-right: 0;
      }
    }
  }
  @media screen  and (max-width: 1325px){
    div.articles {
      flex-wrap: wrap;
      .talk-about {
        width: 100%;
        margin-right: 0;
        margin-bottom: 40px;
        .dots-mobile-auto {
          margin-right: auto;
          margin-left: auto;
          display: block;
        }
        .title {
          text-align: center;
          max-width: 615px;
          margin-left: auto;
          margin-right: auto;
        }
        p {
          text-align: center;
        }
        .button {
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 24px;
        }
      }
      &-block {
        max-width: 768px !important;
        div {

        }
      }
    }
  }
  @media screen  and (max-width: 1325px){
    div.articles {
      flex-wrap: wrap;
      &-block {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 636px){
    div.articles {
      padding: 48px 24px !important;
      &-block {
        .w-50 {
          width: 100% !important;
        }
        .col-12 {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }
</style>